import situation from '@/locales/de/tests/situation';
import problems from '@/locales/de/tests/problems';
import resources from '@/locales/de/tests/resources';

export default {
  home: {
    title: 'Teste Dich',
  },
  result: {
    title: 'Dein Ergebnis',
    nextTests: 'Mehr Tests für Dich:',
  },
  situation: {
    title: 'Erste Hilfe - Test',
    ...situation,
  },
  problems: {
    title: 'Problemlösungstest',
    ...problems,
  },
  resources: {
    title: 'Stärkentest',
    ...resources,
  },
  ressources: {
    title: 'Stärkentest',
    ...resources,
  },
  email: {
    title: 'Ergebnis per E-Mail erhalten',
    label: 'Deine Emailadresse',
    validators: {
      required: 'Eingabe deiner Email erforderlich',
      valid: 'Dies ist eine ungültige Email-Adresse',
    },
    notification: {
      sending: 'Email wird versendet...',
      sent: 'Email verschickt 🎉',
    },
    template: {
      subject: {
        situation: 'Erste Hilfe für Dich | profemina',
        problems: 'Deine Entscheidung | profemina',
        resources: 'Deine Stärken | profemina',
        ressources: 'Deine Stärken | profemina',
      },
      cta: '<a href="mailto:anfrage@profemina.org?subject=Ich möchte persönliche Beratung&body=Liebes profemina-Team,%0D%0A%0D%0Aich möchte gerne individuelle Beratung in Anspruch nehmen.">Für individuelle Beratung hier klicken</a>',
      greeting: 'Guten Tag,',
      message: 'wir freuen uns, dass Du Dich an uns gewandt hast und hoffen, wir können Dir mit dieser Auswertung schon ein wenig weiterhelfen. Hier kannst Du Dein individuelles Ergebnis nochmal in Ruhe nachlesen.',
      signatureGreeting: 'Alles Gute für Deinen weiteren Weg!<br><br>Herzliche Grüße,',
      signature: 'Dein <i>profemina</i>-Beratungsteam',
      ps: 'PS: Sehr gerne sind wir auch weiterhin für Dich da, wenn Du das magst! Du kannst einfach auf diese Mail antworten. Eine unserer erfahrenen Beraterinnen wird Dir dann gerne persönlich schreiben.',
      contact: 'PROFEMINA BERATUNG<br><br>Information, Beratung & Hilfe für Schwangere: <a href="https://www.profemina.org/de-de/">www.profemina.org</a><br><br>Direkte, individuelle und persönliche Beratung in deutscher Sprache (durch Pro Femina e.V., Deutschland):<br><br>WhatsApp-Beratung: <a href="https://www.profemina.org/de-de/whatsapp/">Chat starten</a><br>E-Mail-Beratung: <a href="mailto:info@profemina.org">info@profemina.org</a><br><br>Telefonische Beratung: +49 / 6221 / 60 67 67<br>Kostenlose Rufnummer für Deutschland: 08000 / 60 67 67<br>Kostenlose Rufnummer für Österreich & Schweiz: 00 8000 / 60 67 67 0',
      footer: 'Dieses digitale Beratungsangebot wird Ihnen zur Verfügung gestellt von:<br>Profemina International Impresa Sociale S.r.l. • Via dei Portici 76 • 39100 Bolzano • Italien<br>Registereintrag: Handelsregister Bozen • Eintragungs-, Steuer- und Mehrwertsteuernummer: 03117840219<br>Vertretungsberechtigter: Kristijan Aufiero, Geschäftsführer • <a href="https://www.profemina.org/de-de/impressum">Impressum</a><br><br>UNSER BERATUNGSANGEBOT:<br><i>profemina</i> ist ein unabhängiges, hochqualifiziertes, gemeinnütziges und internationales Beratungsangebot für Frauen im Schwangerschaftskonflikt. Durch objektive Informationen, exzellente und immer vielfältigere Beratung sowie durch konkrete Hilfe möchten wir Frauen im Schwangerschaftskonflikt selbstbestimmte und unabhängige Entscheidungen ermöglichen.<br>Von inzwischen über 100.000 beratenen Frauen haben wir gelernt, dass äußerer Druck durch Umstände und Personen die häufigste Ursache eines Schwangerschaftskonflikts und der Entscheidung für eine Abtreibung ist.<br>Das Anliegen von <i>profemina</i> ist es, uns an die Seite von Schwangeren in Not zu stellen und mit und für alle FRAUEN, DIE DIES WÜNSCHEN, eine belastbare Alternative zur Abtreibung zu erarbeiten und so eine FREIE Entscheidung zu ermöglichen.<br><br>Unsere Arbeit finanziert sich allein aus privaten Spenden unserer Unterstützer, denen Schwangere in Not am Herzen liegen. Deshalb ist unsere Beratung für jede Rat und Hilfe suchende Frau zu 100 Prozent kostenlos.<br><br>Mehr über die Grundsätze unserer Arbeit <a href="https://www.profemina.org/de-de/ueber-uns/unsere-arbeit">finden Sie hier</a>.<br><br>HINWEIS FÜR DEUTSCHLAND:<br>Um Frauen im Schwangerschaftskonflikt bestmögliche und unabhängige Information, Beratung und Hilfe – im Sinne von Art. 1 Abs. 1 und Artikel 2 GG sowie §219 Abs. 1 StGB – zur Verfügung zu stellen, ist <i>profemina</i> NICHT Teil des staatlichen Beratungssystems und stellt auch keine sog. „Beratungsscheine“ aus.<br>Die über unsere digitalen Angebote hinausgehende direkte, individuelle bzw. persönliche Beratung in deutscher Sprache erfolgt durch unseren Kooperationspartner Pro Femina e.V., Deutschland.<br><br>DATENSCHUTZ-INFORMATION:<br>Alle Ihre Daten und Angaben werden von Pro Femina e.V. streng vertraulich behandelt, nicht an Unbefugte weitergegeben und unterliegen dem vollen Schutz der DSGVO (Datenschutz-Grundverordnung)! Alle wichtigen Informationen zur Datenverarbeitung insbesondere im Zusammenhang mit der Datenschutz-Grundverordnung (DSGVO) <a href="https://www.profemina.org/de-de/datenschutz">finden Sie hier</a>.<br><br>HINWEIS ZUR VERTRAULICHKEIT:<br>Diese E-Mail und die zugehörigen Anlagen (sofern vorhanden) sind ausschließlich für die Verwendung durch den bzw. die Adressaten vorgesehen. Diese E-Mail und die zugehörigen Anlagen (sofern vorhanden) enthalten möglicherweise Informationen, die unter geltendem Recht als vertraulich und nicht offenlegungspflichtig gelten.<br>Sollten Sie nicht der vorgesehene Empfänger dieser E-Mail sein, ist es Ihnen untersagt, diese Sendung offenzulegen, zu reproduzieren, zu verteilen, zu verbreiten oder auf andere Weise davon Gebrauch zu machen. Das Senden dieser E-Mail an andere Personen als den beabsichtigten Empfänger bedeutet nicht den Verzicht auf jegliche Rechte oder Vorrechte. Falls Sie diese E-Mail versehentlich erhalten haben, setzen Sie bitte den Absender durch eine entsprechende Antwort-E-Mail sofort davon in Kenntnis und löschen Sie diese E-Mail unverzüglich von Ihrem System.',
    },
  },
  rating: {
    title: 'Wir freuen uns über Dein Feedback 🤗',
    question1: '<strong>Konnten wir Dir mit diesem Test weiterhelfen?</strong>',
    question2: '<strong>Hast du dich während der Beratung wohlgefühlt?</strong>',
    question3: '<strong>Würdest du wieder unsere App benutzen?</strong>',
    textarea: {
      question: '<strong>Gibt es etwas, was Du uns gerne mitgeben würdest?</strong>',
      label: 'Deine Anmerkung (optional)',
    },
    processing: 'Bewertung wird verarbeitet...',
    thanks: 'Vielen Dank für deine Bewertung 🤗',
  },
  welcome: 'Willkommen bei der Test App von <i>profemina</i>',
  language_switcher: {
    de: 'Deutsch',
    en: 'Englisch',
    pt: 'Portugiesisch',
    it: 'Italienisch',
  },
  bottom_bar: {
    next: 'Weiter',
    advice: 'Mein Ergebnis',
  },
  refreshApp: {
    title: '<i>profemina</i> wird besser 🎉',
    description: 'Eine neue Version ist verfügbar. Bitte klicke auf "Aktualisieren", um auf dem neuesten Stand zu sein.',
    button: 'Aktualisieren',
  },
  loading: 'Deine individuelle Beratung wird erstellt',
  notFound: {
    title: '404 - Seite nicht gefunden',
    subtitle: 'Oh! Entschuldigung...',
    text: 'Entweder haben wir oder du dich auf einen falschen Pfad geführt...',
  },
  connectivity: {
    offline: 'Du bist leider offline gegangen...',
    online: 'Wie schön, Du bist wieder online 🤗',
  },
};
